<template>
  <div class="system">
    <menu-system-component 
    :items="menuItems" 
    :notifications='notifications'
    :color='colorMenu' 
    ref="menu"></menu-system-component>
    <v-main class="pa-0">
      <v-container
              class="fill-height pt-0 mt-0"
              fluid
              @click.stop="$refs.menu.mini = true"
      >
        <v-row >
          <ul class="v-breadcrumbs">
            <li>Ud está en:</li>
          </ul>
          <v-breadcrumbs class="pl-1" :items="items">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-row>
        <v-row
          class="pt-0 mt-0"
          align="stretch"
          justify="space-around"
          style="height: calc(100vh - 110px);"
        >
            <router-view @SetcolorMenu="changeColorMenu" />
        </v-row>
        <chat-system-component/>
      </v-container>
    </v-main>

  </div>
</template>
<style lang="scss">
  .border-bottom-1{
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  }
  .v-content{
    background: #F3F5F9;
  }
  .m-active{
    background: #014D85;
    color: #FFFFFF !important;
  }
  .v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item{
    padding-left: 50px;
  }
</style>
<script>
  // @ is an alias to /src
  import MenuSystemComponent from '@/components/system/MenuSystemComponent.vue';
  import ChatSystemComponent from '@/components/system/ChatSystemComponent.vue';

  export default {
    name: 'System',
    metaInfo: {
      title: 'Neocity - sistema',
      meta: [
        { name: 'title',content:'Neocity - sistema'},
        { name: 'description',content:'esta es una descripcion'},
      ]
    },
    components: {
      MenuSystemComponent,
      ChatSystemComponent
    },
    data() {
      return {
        colorMenu:'primary',
        items: [
          {
            text: 'Dashboard',
            disabled: false,
            href: '/system/dashboard',
          },
          {
            text: 'Perfil de Empresa',
            disabled: true,
            href: '/system/generator/profile-company',
          },
        ],
        menuItems: [
          {
              title: 'Inicio',
              icon: 'mdi-home',
              href: '/system/generator/dashboard'
          },
          {
              title: 'Generador',
              icon: 'mdi-flash',
              active:false,
              items: [ {
                  title: 'Inicio',
                      icon: 'mdi-home',
                    href: '/system/generator/dashboard',
                  },
                    {   title: 'Perfil Empresa',
                      icon: 'mdi-circle-medium',
                      href:'/system/generator/profile-company'
                  },
                  {
                      title: 'Perfil Administrador',
                      icon: 'mdi-circle-medium',
                      href:'/system/generator/profile-administrator'
                  },
                  {
                      title: 'Mis Empresas',
                      icon: 'mdi-circle-medium',
                      href: '/system/generator/all-companies'
                  },
                  {
                      title: 'Mis Solicitudes',
                      icon: 'mdi-circle-medium',
                      href: '/system/generator/my-request'
                  },
                  {
                      title: 'Mis Ofertas',
                      icon: 'mdi-circle-medium',
                      href: '/system/generator/my-offers'
                  },
                  {
                      title: 'Mis Cierres',
                      icon: 'mdi-circle-medium',
                      href: '/system/generator/my-closing'
                  },
                {
                      title: 'Mis Contratos',
                      icon: 'mdi-circle-medium',
                      href: '/system/generator/my-contracts'
                  },
                  
              ],
          },
           {
              title: 'Consumidor',
              icon: 'mdi-ev-station',
              active:false,
              items: [
                 {
                      title: 'Inicio',
                      icon: 'mdi-home',
                      href: '/system/consumer/dashboard'
                  },
                  {
                      title: 'Perfil Empresa',
                      icon: 'mdi-circle-medium',
                      href:'/system/consumer/profile-company'
                  },
                  {
                      title: 'Ofertas de Suministro',
                      icon: 'mdi-circle-medium',
                      href:'/system/consumer/energy-offers'
                  },
                   {
                      title: 'Seguimeinto de solicitudes',
                      icon: 'mdi-circle-medium',
                      href:'/system/consumer/request-tracking'
                  },
                   {
                      title: 'Cierre',
                      icon: 'mdi-circle-medium',
                      href:'/system/consumer/closing'
                  },
                  {
                      title: 'Puntos de Retiro',
                      icon: 'mdi-circle-medium',
                      href:'/system/consumer/withdrawal-points'
                  },
                  {
                      title: 'Mis Cierres',
                      icon: 'mdi-circle-medium',
                      href:'/system/consumer/my-closing'
                  },
                   {
                      title: 'Mis Contratos',
                      icon: 'mdi-circle-medium',
                      href:'/system/consumer/my-contracts'
                  },
                  
              ]
          },
          { 
            title: 'Reportes',
            icon: 'mdi-file-chart',
            active:false,
              items: [
                {
                  title: 'Inicio',
                  icon: 'mdi-circle-medium',
                  href:'/system/reports/dashboard' 
                },
                {
                  title: 'Mis reportes',
                  icon: 'mdi-circle-medium',
                  href:'/system/reports/my-reports' 
                },
                {
                  title: 'Crear Reporte',
                  icon: 'mdi-circle-medium',
                  href:'/system/reports/create-report' 
                },
                {
                  title: 'Pago 1',
                  icon: 'mdi-circle-medium',
                  href:'/system/reports/payment' 
                },
                 {
                  title: 'Pago 2',
                  icon: 'mdi-circle-medium',
                  href:'/system/reports/payment-2' 
                },
                {
                  title: 'Detalle colaborador',
                  icon: 'mdi-circle-medium',
                  href:'/system/reports/collaborator-detail' 
                }
              ]
          },
           { 
            title: 'Pagos',
            icon: 'mdi-currency-usd',
            active:false,
              items: [
                  {
                      title: 'Plan Neocity',
                      icon: 'mdi-circle-medium',
                      href:'/system/payment/my-plan'
                  },
                 {
                    title: 'Pago',
                    icon: 'mdi-circle-medium',
                    href:'/system/payment/payment' 
                  },
                   {
                    title: 'Pago 2',
                    icon: 'mdi-circle-medium',
                    href:'/system/payment/payment-2' 
                  },
                   {
                    title: 'Pago exitoso',
                    icon: 'mdi-circle-medium',
                    href:'/system/payment/payment-success' 
                  },
              ]
            },
          { title: 'Contacto', icon: 'mdi-email-outline', href:'/system/contact' },
          { title: 'Sobre Neocity', icon: 'mdi-information-outline', href:'/system/terms' },
          { title: 'Terminos y condiciones', icon: 'mdi-file-check-outline', href:'/system/about' },
          { title: 'Card', icon: 'mdi-circle-medium', href:'/system/card-master' },
        ],
        notifications: [
          { title: 'Actualizar documentos (1) >>' },
          { title: 'Definir representante Legal (1) >>' },
          { title: 'Tienes ofertas sin publicar (2) >>' },
        ],
      }
    },
    methods: {
      changeColorMenu(color){
          this.colorMenu = color;
      }
    }
  }
</script>